import React from 'react';
import Title from '../../components/Title/Title';
import Auxiliary from '../../util/Auxiliary';
import List from './List';

const Index = () => {
  return (
    <Auxiliary>
      <Title>Data Kompetensi</Title>
      <List />
    </Auxiliary>
  );
}

export default Index;